/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Overview_Completely1Inputs */

const id_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sepenuhnya`)
};

const ms_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sepenuhnya`)
};

const da_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuldført`)
};

const de_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komplett`)
};

const en_us2_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completely`)
};

const es_es2_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completamente`)
};

const es_mx2_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completamente`)
};

const fil_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganap`)
};

const fr_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complètement`)
};

const it_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completamente`)
};

const hu_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljesen`)
};

const nl_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledig`)
};

const no_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullstendig`)
};

const pl_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W pełni`)
};

const pt_br2_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completamente`)
};

const pt_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completamente`)
};

const ro_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complet`)
};

const fi_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täysin`)
};

const sv_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullständig`)
};

const vi_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn toàn`)
};

const tr_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamamen`)
};

const cs_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úplně`)
};

const bg_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Напълно`)
};

const ru_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полностью`)
};

const uk_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повністю`)
};

const ar_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بالكامل`)
};

const hi_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूरी तरह से`)
};

const th_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สมบูรณ์`)
};

const ja_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完全`)
};

const zh_cn2_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完美通关`)
};

const zh_hant1_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完美通關`)
};

const ko_offerdetail_overview_completely1 = /** @type {(inputs: Offerdetail_Overview_Completely1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`완전히`)
};

/**
* | output |
* | --- |
* | "Completely" |
*
* @param {Offerdetail_Overview_Completely1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_overview_completely1 = /** @type {((inputs?: Offerdetail_Overview_Completely1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Overview_Completely1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_overview_completely1(inputs)
	if (locale === "ms") return ms_offerdetail_overview_completely1(inputs)
	if (locale === "da") return da_offerdetail_overview_completely1(inputs)
	if (locale === "de") return de_offerdetail_overview_completely1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_overview_completely1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_overview_completely1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_overview_completely1(inputs)
	if (locale === "fil") return fil_offerdetail_overview_completely1(inputs)
	if (locale === "fr") return fr_offerdetail_overview_completely1(inputs)
	if (locale === "it") return it_offerdetail_overview_completely1(inputs)
	if (locale === "hu") return hu_offerdetail_overview_completely1(inputs)
	if (locale === "nl") return nl_offerdetail_overview_completely1(inputs)
	if (locale === "no") return no_offerdetail_overview_completely1(inputs)
	if (locale === "pl") return pl_offerdetail_overview_completely1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_overview_completely1(inputs)
	if (locale === "pt") return pt_offerdetail_overview_completely1(inputs)
	if (locale === "ro") return ro_offerdetail_overview_completely1(inputs)
	if (locale === "fi") return fi_offerdetail_overview_completely1(inputs)
	if (locale === "sv") return sv_offerdetail_overview_completely1(inputs)
	if (locale === "vi") return vi_offerdetail_overview_completely1(inputs)
	if (locale === "tr") return tr_offerdetail_overview_completely1(inputs)
	if (locale === "cs") return cs_offerdetail_overview_completely1(inputs)
	if (locale === "bg") return bg_offerdetail_overview_completely1(inputs)
	if (locale === "ru") return ru_offerdetail_overview_completely1(inputs)
	if (locale === "uk") return uk_offerdetail_overview_completely1(inputs)
	if (locale === "ar") return ar_offerdetail_overview_completely1(inputs)
	if (locale === "hi") return hi_offerdetail_overview_completely1(inputs)
	if (locale === "th") return th_offerdetail_overview_completely1(inputs)
	if (locale === "ja") return ja_offerdetail_overview_completely1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_overview_completely1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_overview_completely1(inputs)
	return ko_offerdetail_overview_completely1(inputs)
});
export { offerdetail_overview_completely1 as "offerDetail.overview.completely" }